import React from 'react'
import axios from 'axios'
import {find} from 'lodash'
import {
  StripeProvider, Elements, injectStripe,
  CardNumberElement, CardExpiryElement, CardCVCElement
} from 'react-stripe-elements'

import { subscribe } from '~/redux/user/subscription';
import Paypal from '~/components/Paypal'
import {AmazonJS} from '~/components/AmazonPay/AmazonJS'
import AmazonPay from '~/components/AmazonPay'
import './style.css'

class StripeEl extends React.Component {
  constructor(props) {
    super(props)    
    this.state = {}
  }

  async componentDidMount() {
    await AmazonJS()
  }

  render() {
    var complete = this.state.valid && !this.state.focused
    var color = this.props.theme === 'dark' && complete ? '#fff' : '#000'

    return (
      <div className={
        'stripe-input' + ( this.state.valid ? ' ticked site-color-before' : '' )
        + (complete ? ' complete' : '')
      }>
        <div className="title">{ this.props.title }</div>
        <this.props.El
          style={ this.props.style || { base: { fontSize: '12px', color: color } } }
          onChange={ o => this.onChange(o) }
          onFocus={ _ => this.setState({ ...this.state, focused: true }) }
          onBlur={ _ => this.onBlur() }
          placeholder={ this.props.title || '' }
          elementRef={ el => { this.inputEl = el } } />
      </div>
    )
  }

  onChange(o) {
   if (this.state.valid !== o.complete)
      this.setState({...this.state, valid: o.complete })

    this.props.done(o.complete, o)
  }

  onBlur(){
    this.setState({ ...this.state, focused: false })
  }

  setValue(element, value) {
    element.parentElement.classList.add(...['complete', 'ticked', 'site-color-before'])
    element.value = value || ''
  }
}

class InputEl extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  onBlur = () =>{
    this.setState({ ...this.state, focused: false })
    if (this.props.name == 'address_zip'){
      this.state.city && this.setValue(document.querySelector('input[name="address_city"]'),  this.state.city)
      this.state.country && this.setValue(document.querySelector('input[name="address_country"]'), this.state.country)
      this.state.state && this.setValue(document.querySelector('input[name="address_state"]'),this.state.state)
    }
  }

  getAddress = (value) => {
    axios.get(`https://maps.googleapis.com/maps/api/geocode/json?components=postal_code:${value}&key=AIzaSyCjULGl-zqfHzWOrRwHpanj3q7uXHM4OPY`)
    .then( response =>{
      if(response.data.results.length > 0){
        const results = response.data.results[0]
        this.setState({
          country: (find(results['address_components'], (item)=>{return item.types.includes('country')}))['short_name'],
          state: (find(results['address_components'], (item) => { return item.types.includes('administrative_area_level_1') }))['short_name'],
          city: (find(results['address_components'], (item) => { 
            return item.types.includes('locality') || item.types.includes('postal_town') 
          }))['short_name']
        })
      }
    })
  }

  onChange = (o) => {
    var valid = !!this.el.value
    if (this.state.valid !== valid)
      this.setState({...this.state, valid: valid})

    this.props.done(valid)
    if (this.props.name == 'address_zip'){
      if (this.el.value.length > 3)
        this.getAddress(this.el.value)
    }
  }

  setValue(element, value) {
    element.parentElement.classList.add(...['complete', 'ticked', 'site-color-before'])
    element.value = value || ''
  }
  
  render() {
    var ticked = this.state.valid
    var complete = !this.state.focused && this.state.valid
    

    return (
      <div className={
        'our-input'
        + (complete ? ' complete' : '')
        + (ticked ? ' ticked site-color-before' : '')
      }>
        <div className="title">{ this.props.title }</div>
        <input
          type="text"
          ref={ el => { this.el = el; this.props.elementRef(el) } }
          onChange={ e => this.onChange(e) }
          onFocus={ _ => this.setState({...this.state, focused: true }) }
          onBlur={ _ => this.onBlur() }
          placeholder={ this.props.title } 
          name={this.props.name}/>
      </div>
    )
  }
}

class StripeForm extends React.Component {
  constructor(props) {
    super(props)
    if (this.props.formRef)
      this.props.formRef(this)
    this.state = { 
      isReady: false,
      fields: props.fields
     }
  }

  render() {
    if (this.props.layout === 'row')
      return (
        <div className={ `cc-form ${this.props.theme} row-layout`}>
          { this.ccForm() }
          { this.addressForm() }
        </div>
      )

    if (this.props.layout === 'FITNESS'){
      return (
        <div className={ `cc-form`}>
          <h3>Enter your billing details below:</h3>
          { this.addressForm(this.state.fields) }
          <h3>Payment Information</h3>
          { this.ccForm(this.state.fields) }
        </div>
      )
    }

   return (
      <div className={ `cc-form ${this.props.theme}`}>
        <div className="left-form">
          <div className="title">{this.state.fields.billingAddressHeading}</div>
          { this.addressForm(this.state.fields) }
        </div>
        <div className="right-form">
          <div className="title">{this.state.fields.cardDetailsHeading}</div>
          { this.ccForm(this.state.fields) }
        </div>
      </div>
    )
  }

  addressForm(fields) {
    return(
      <div>
        <InputEl
          title={fields.nameOnCard}
          done={ d => this.setReady('name', d) }
          elementRef={ el => { this.nameInput = el } } 
          name="customer_name"/>
        <InputEl
          title={fields.streetAddress}
          done={ d => this.setReady('address', d) }
          elementRef={ el => { this.addressInput = el } } />
        <div className="zip-city">
          <InputEl
            title={fields.zipCode}
            done={ d => this.setReady('zip', d) }
            elementRef={ el => { this.zipInput = el } }
            name="address_zip"/>
          <InputEl
            title={fields.city}
            done={d => { this.setReady(null,d) }}
            elementRef={el => { this.cityInput = el }}
            name="address_city" />
        </div>
      
        <div className="state-country">
          <InputEl
            title={fields.state}
            done={d => { this.setReady(null,d) }}
            elementRef={el => { this.stateInput = el }} 
            name="address_state"/>
          
          <InputEl
            title={fields.country}
            elementRef={el => { this.countryInput = el }}
            done={d => { this.setReady(null,d) }}
            name="address_country" />
        </div>
        {this.props.leftContent}
      </div>  
    )    
  }

  displayContainers(filteredHandlers, handlersMap) {
    const isStripeLoading = this.props.stripeLoading
    return filteredHandlers.map((key, i) => {
      const lowKey = key.toLowerCase() 
      const paymentId = lowKey === 'paypal' ? 'vlTransactionId' : 'paymentUniqueId'
      const Handler = handlersMap[lowKey]
      return (
        <Handler
          key={i}
          disabled={isStripeLoading}
          style={{ marginBottom: '10px' }}
          currentPlan={this.props.plan}
          overlay={this.props.overlay}
          subscribe={(id) => subscribe({  
            [paymentId]: id,
            subscription: lowKey,
            plan: this.props.plan, 
            offerCode:
              this.props.offerCode &&
              this.props.offerCode.code
          }).then(data => this.props.success(data))}
        />
      ) 
    })
  }

  ccForm(fields) {
    
    let handlersMap = {}
    if(this.props.type && (this.props.type.toLowerCase() === "ppv" || this.props.type.toLowerCase() === "svod+ppv")) {
      handlersMap = {
        amazon: AmazonPay
      }
    } else {
      handlersMap = {
        amazon: AmazonPay,
        paypal: Paypal
      }
    }
    const filteredHandlers = Object.keys(window.settings.paymentProviders).filter(f => { 
      return Object.keys(handlersMap).includes(f.toLowerCase())
    })
    return (
      <div>
        <StripeEl
          theme={ this.props.theme }
          style={ this.props.stripeElStyle }
          El={CardNumberElement}
          title={fields.cardNumber}
          done={ d => this.setReady('number', d) } />
        <div className="exp-cvc">
          <StripeEl
            theme={ this.props.theme }
            El={CardExpiryElement}
            style={ this.props.stripeElStyle }
            title={fields.expiration}
            done={ d => this.setReady('expiry', d) } />
          <StripeEl
            theme={ this.props.theme }
            style={ this.props.stripeElStyle }
            El={CardCVCElement}
            title={fields.cvc}
            done={ d => this.setReady('cvc', d) } />
        </div>
        { this.props.rightContent }
        { (filteredHandlers.length > 0 && (this.props.submitCaption && this.props.submitCaption.toLowerCase() !== 'update')) && 
          <React.Fragment>
            <span className='or-handlers'>Or</span> 
            <React.Fragment>
              { this.displayContainers(filteredHandlers, handlersMap) }
            </React.Fragment>
          </React.Fragment> }
      </div>
    )
  }

  setReady(field, ready) {
    var readySet = this.readySet = this.readySet || new Set()
    if(field !== null){
      if (ready) readySet.add(field)
      else readySet.delete(field)
    }

    var isReady = (readySet.size === 6) && (this.cityInput.value !== '' && this.stateInput.value !== '' && this.countryInput.value !== '' && this.nameInput.value !== '' )
    if (isReady !== this.state.isReady) {
      if (this.props.onReady)
        this.props.onReady(isReady)
      this.setState({...this.state, isReady: isReady })
    }
  }

  createToken() {
    return this.props.stripe.createToken({
      name: this.nameInput.value,
      address_line1: this.addressInput.value,
      address_city: this.cityInput.value,
      address_state: this.stateInput.value,
      address_country: this.countryInput.value,
      address_zip: this.zipInput.value
    }).then(o => {
      if (o.error)
        throw new Error(o.error.message || 'Error!')
      return o.token
    })
  }
}

var IStripeForm = injectStripe(StripeForm)

class StripeCCForm extends React.Component {
constructor(props) {
    super(props)
    this.state = {
      fields: props.fields
    }
  }
  render() {
    return (
      <StripeProvider apiKey={ this.props.apiKey }>
        <Elements
          fonts={this.props.fonts || []}
        >
          <IStripeForm
            theme={ this.props.theme || 'dark' }
            layout={ this.props.layout }
            formRef={ el => this.props.formRef(el) }
            stripeElStyle={ this.props.stripeElStyle }
            onReady={ this.props.onReady }
            fields = {this.state.fields}
            leftContent={ this.props.leftContent }
            rightContent={ this.props.rightContent }
            {...this.props}
            />
        </Elements>
      </StripeProvider>
    )
  }
}

export default StripeCCForm